import { Injectable } from '@nestjs/common';
import { Repository, Raw, getConnection } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import {TransferAction} from './transfer-action.entity';
import {TransferActionDTO} from './dto/transfer-action.dto';
import {TransferActionAdapter} from './dto/transfer-action.adapter';
import { TransferActionResponseModel, AllTransferActionResponseModel,TransferActionDto } from '@gtpl/shared-models/hrms';
import { TransferActionRequest } from './dto/transfer-action-request';

// import { TransferActionRequest } from './dto/transfer-action.request';

@Injectable()
export class TransferActionService {
    constructor(
        @InjectRepository(TransferAction)
        private transferActionRepository: Repository<TransferAction>,
        private Adapter: TransferActionAdapter,
    ){}
    /**
     * get transferActionId details
     * @param transferActionId 
     */
    // @LogActions({isAsync: true})
    async getTransferActionDetailsWithoutRelations(transferActionId: number): Promise<TransferAction> {
        // tslint:disable-next-line: typedef
        const transferActionResponse = await this.transferActionRepository.findOne({
          where: {transferActionId: Raw(alias => `transfer_action_id = '${transferActionId}'`)},
        });
        if (transferActionResponse) {
          return transferActionResponse;
        } else {
          return null;
        }
      }

      async createTransferAction(transferActionDto: TransferActionDTO, isUpdate: boolean): Promise<TransferActionResponseModel> {
        // console.log(statesDto);
        try {
          // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
          if (!isUpdate) {
            const transferActionEntity = await this.getTransferActionDetailsWithoutRelations(transferActionDto.transferActionId);
            if (transferActionEntity) {
              //return new InformationMessageError(11104, "State already exists");
              throw new ErrorResponse(11104, 'Transfer Action already exists');
            }
          }
          else{
            const transferActionEntity = await this.getTransferActionDetailsWithoutRelations(transferActionDto.transferActionId);
            if (transferActionEntity) {
              if(transferActionEntity.transferActionId!=transferActionDto.transferActionId) {
                throw new ErrorResponse(11104, 'Transfer Action  already exists');      
            }
              //return new InformationMessageError(11104, "State already exists");
            }
          }
          const convertedTransferActionEntity: TransferAction = this.Adapter.convertDtoToEntity(transferActionDto,isUpdate);
          const savedExpensesCategoryEntity: TransferAction = await this.transferActionRepository.save(
            convertedTransferActionEntity
          );
          const savedTransferActionDto: TransferActionDTO = this.Adapter.convertEntityToDto(convertedTransferActionEntity);
            // console.log(savedStateDto);
          if (savedTransferActionDto) {
            // generating resposnse
            const response = new TransferActionResponseModel(true,1,isUpdate? 'Transfer Action Updated Successfully': 'Transfer Action Created Successfully')
            return response
          } else {
            //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
            throw new ErrorResponse(11106,'Transfer Action  saved but issue while transforming into DTO');
          }
        } catch (error) {
          // when error occures while saving the data , the execution will come to catch block.
          // tslint:disable-next-line: typedef
          throw error;
        }
      }  

      async getAllTransferActions(): Promise<AllTransferActionResponseModel> {
        // const page: number = 1;
        
        try {
          const TransferActionDtos: TransferActionDTO[] = [];
          //retrieves all companies
          const transferActionEntities: TransferAction[] = await this.transferActionRepository.find({order :{'transferActionId':'ASC'}});
          //console.log(statesEntities);
          if (transferActionEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            transferActionEntities.forEach(transferActionEntity => {
              const convertedExpensesCategoryDto: TransferActionDTO = this.Adapter.convertEntityToDto(
                transferActionEntity
              );
              TransferActionDtos.push(convertedExpensesCategoryDto);
            });
            const response = new AllTransferActionResponseModel(true,1,'Transfer Action  retrieved successfully',TransferActionDtos);
            //generated response
            return response
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        
        } catch (err) {
          throw err;
        }
      }
      async getAllActiveTransferActions(): Promise<AllTransferActionResponseModel> {
        // const page: number = 1;
        try {
            const transferActionDto: TransferActionDTO[] = [];
            //retrieves all expenses Categories
            const transferActionEntities: TransferAction[] = await this.transferActionRepository.find({ order: { 'transferActionId': 'ASC' },where:{isActive:true},
           });
         console.log(transferActionEntities)
            if (transferActionEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                transferActionEntities.forEach(transferActionEntity => {
                    const convertedTransferActionDto: TransferActionDTO = this.Adapter.convertEntityToDto(
                      transferActionEntity
                      
                    );
                    transferActionDto.push(convertedTransferActionDto);
                });
                const response = new AllTransferActionResponseModel(true, 11108, "TransferAction retrieved successfully", transferActionDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found'); transferActionDto
            }
        } catch (err) {
            throw err;
        }
    }
      async activateOrDeactivateTransferAction(transferActionReq: TransferActionRequest): Promise<TransferActionResponseModel> {
        try {
            const transferActionExists = await this.getTransferActionById(transferActionReq.transferActionId);
            if (transferActionExists) {
                if (transferActionReq.versionFlag !== transferActionExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Transfer Action  information.Refresh and try again');
                } else {
                    
                        const transferActionStatus =  await this.transferActionRepository.update(
                            { transferActionId: transferActionReq.transferActionId },
                            { isActive: transferActionReq.isActive,updatedUser: transferActionReq.updatedUser });
                       
                        if (transferActionExists.isActive) {
                            if (transferActionStatus.affected) {
                                const transferActionResponse: TransferActionResponseModel = new TransferActionResponseModel(true, 10115, 'TransferAction is de-activated successfully');
                                return transferActionResponse;
                            } else {
                                throw new ErrorResponse(10111, 'TransferAction is already deactivated');
                            }
                        } else {
                            if (transferActionStatus.affected) {
                                const transferActionResponse: TransferActionResponseModel = new TransferActionResponseModel(true, 10114, 'TransferAction is activated successfully');
                                return transferActionResponse;
                            } else {
                                throw new ErrorResponse(10112, 'TransferAction is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
      async getActiveTransferActionById(transferActionReq: TransferActionRequest): Promise<TransferActionResponseModel> {
        try {
          //retrieves all companies
          const transferActionEntities: TransferAction = await this.transferActionRepository.findOne({
              where:{transferActionId:transferActionReq.transferActionId}
              });
              
              const transferActionData: TransferActionDTO = this.Adapter.convertEntityToDto(transferActionEntities);
              if (transferActionData) {
                  const response = new TransferActionResponseModel(true, 11101 , 'TransferAction retrived Successfully',transferActionData);
                  return response;
              }
              else{
                  throw new ErrorResponse(11106,'Something went wrong');
              }
              // generating resposnse
      } catch (err) {
          throw err;
      }
    }

    async getTransferActionById(transferActionId: number): Promise<TransferAction> {
        //  console.log(employeeId);
            const Response = await this.transferActionRepository.findOne({
            where: {transferActionId: transferActionId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }
}
